import React from "react";
import mapa from "../images/mapa.png";
import { ContactForm } from "../components/formularios/ContactForm";

export default function QuienSomos() {
  const AnyReactComponent = ({ text }) => <div>{text}</div>;

  return (
    <>
      <div className="container__contact">
        <ContactForm />
      </div>
      <div>
        <img src={mapa} style={{ width: "100%" }} />
      </div>
    </>
  );
}
